import React from 'react';
import PropTypes from 'prop-types';
import styles from './ContentCardCheckbox.module.less';

const ContentCardCheckbox = ({
  checked,
  onChange,
  className,
  ...otherProps
}) => {
  let classes = [className, 'form', styles.checkboxForm];
  let checkboxStyleOverwrite = { margin: '2px -4px -12px 2px' };

  return (
    <div className={classes.join(' ')} {...otherProps}>
      <label className="checkbox">
        <input
          type="checkbox"
          checked={checked}
          onChange={e => onChange(e.target.checked)}
        />
        <div className="checkbox" style={checkboxStyleOverwrite} />
      </label>
    </div>
  );
};
ContentCardCheckbox.displayName = 'ContentCardCheckbox';
ContentCardCheckbox.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
};

export default ContentCardCheckbox;
